<template>
    <div class="flow-compare flow-container">
        <div class="params-header" style="margin-top: 20px">
            <Card :no-border="false">
                <div class="condition-line" style="display: flex; border-bottom: 1px solid #f7f7f7">
                    <div style="block">
                        <EntityLocation @change="onEntityChanged"></EntityLocation>
                        <SelectDoor :entityID="searchParam.EntityID" @select="onDoorChanged"></SelectDoor>
                    </div>
                    <div style="flex: 7; text-align: right">
                        <div class="block">
                            <el-select style="width: 100px" v-model="type" size="mini">
                                <el-option label="分钟" value="1"> </el-option>
                                <el-option label="天" value="2"> </el-option>
                            </el-select>
                        </div>
                        <div class="block" v-if="type == '1'">
                            <el-date-picker
                                v-model="date"
                                format="YYYY-MM-DD"
                                size="mini"
                                value-format="YYYY-MM-DD"
                                type="date"
                                placeholder="选择日期"
                            >
                            </el-date-picker>
                        </div>
                        <div class="block" v-if="type == '2'">
                            <el-date-picker
                                size="mini"
                                v-model="dateRange"
                                type="daterange"
                                range-separator="至"
                                start-placeholder="开始日期"
                                format="YYYY-MM-DD"
                                value-format="YYYY-MM-DD"
                                end-placeholder="结束日期"
                            ></el-date-picker>
                        </div>
                        <div class="block">
                            <el-button type="primary" size="mini" @click="onSearch">查询</el-button>
                        </div>
                    </div>
                </div>
            </Card>
        </div>
        <Card :no-border="false" style="margin-top: 15px">
            <template #header>
                <div class="card-header">
                    <span>详细数据</span>
                    <div class="buttons">
                        <ExportButton :url="exportUrl" :param="searchParam"></ExportButton>
                    </div>
                </div>
            </template>
            <list-page :showTitle="false" :api="searchUrl" :searchParam="searchParam" :showPager="true" :showSearch="false" ref="page">
                <el-table-column type="index" width="80px" label="序号"></el-table-column>
                <el-table-column prop="Name" label="时间"></el-table-column>
                <el-table-column prop="ChildName" label="位置"></el-table-column>
                <el-table-column prop="DataIn" label="进人数"></el-table-column>
                <el-table-column prop="DataOut" label="出人数"></el-table-column>
            </list-page>
        </Card>
    </div>
</template>
<script>
export default {
    name: "door",
    components: {},
    data() {
        return {
            type: "1",
            searchParam: {
                BeginTime: "",
                EndTime: "",
                EntityID: "",
                DoorID: [],
            },
            date: "",
            dateRange: [],
            dataList: [],
        };
    },
    computed: {
        searchUrl() {
            return this.type == "1" ? "/FlowData/GetEntityDoorMinDetails" : "/FlowData/GetEntityDoorDayDetails";
        },
        exportUrl() {
            return this.type == "1" ? "/FlowData/ExportEntityDoorMinDetails" : "/FlowData/ExportEntityDoorDayDetails";
        },
    },
    created() {
        const now = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        this.date = now.format("yyyy-MM-dd");
        this.dateRange = [start.format("yyyy-MM-dd"), now.format("yyyy-MM-dd")];
        this.searchParam.BeginTime = this.date;
        let end = new Date(this.date);
        end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
        this.searchParam.EndTime = end.format("yyyy-MM-dd");
    },
    methods: {
        loadData() {},
        onEntityChanged(e) {
            this.searchParam.EntityID = e.EntityID;
        },
        onDoorChanged(e) {
            this.searchParam.DoorID = [];
            if (e.DoorID != "") {
                this.searchParam.DoorID.push(e.DoorID);
            }
        },
        onSearch() {
            if (this.type == "1") {
                if (this.date == "") {
                    this.$warn("请选择日期！");
                    return;
                }
                let end = new Date(this.date);
                this.searchParam.BeginTime = end.format("yyyy-MM-dd");
                end.setTime(end.getTime() + 3600 * 1000 * 24 * 1);
                this.searchParam.EndTime = end.format("yyyy-MM-dd");
            }

            if (this.type == "2") {
                if (!this.dateRange || this.dateRange.length == 0) {
                    this.$warn("请选择日期！");
                    return;
                }
                this.searchParam.BeginTime = this.dateRange[0];
                this.searchParam.EndTime = this.dateRange[1];
            }
            this.$refs.page.searchData();
        },
    },
};
</script>
